import React, { useCallback, useEffect, useRef, useState } from 'react';
import moment from 'moment-timezone';

import styles from './countdownStyles.scss';

const Countdown: React.FC<{ date: Date; inline?: boolean }> = ({ date, inline }) => {
  const duration = useRef(
    moment.duration(moment.tz(new Date(date), 'America/New_York').diff(moment()))
  );
  const [seconds, setSeconds] = useState(duration.current.seconds());
  const [minutes, setMinutes] = useState(duration.current.minutes());
  const [hours, setHours] = useState(Math.floor(duration.current.asHours()));

  const countdownTimer = useCallback(() => {
    duration.current.subtract(1, 's');
    setSeconds(duration.current.seconds());
    setMinutes(duration.current.minutes());
    setHours(Math.floor(duration.current.asHours()));
  }, [duration]);

  const intervalId = useRef<NodeJS.Timeout | null>(null);
  const startTimer = useCallback(() => {
    intervalId.current = setInterval(countdownTimer, 1000);
  }, [countdownTimer]);

  useEffect(() => {
    if (intervalId.current) {
      window.clearInterval(intervalId.current);
    }
    duration.current = moment.duration(
      moment.tz(new Date(date), 'America/New_York').diff(moment())
    );
    countdownTimer();
    startTimer();

    return (): void => {
      if (intervalId.current) {
        window.clearInterval(intervalId.current);
      }
    };
  }, [intervalId, startTimer, date, countdownTimer]);

  if (inline)
    return (
      <span data-testid="countdown">
        <strong>{hours}</strong> hours : <strong>{minutes}</strong> minutes :{' '}
        <strong>{seconds}</strong> seconds
      </span>
    );

  return (
    <div data-testid="countdown">
      <div className={styles.countdownColumns}>
        <span>Hours</span>
        <span>Minutes</span>
        <span>Seconds</span>
      </div>
      <div className={styles.countdownColumns}>
        <span>{hours}</span>
        <span>{minutes}</span>
        <span>{seconds}</span>
      </div>
    </div>
  );
};

export default Countdown;
